import { abyssColors, offWhiteGray, primary } from '@/theme/colors';
import { Select, Stack, TextField } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const ExceptionsGrid = muiStyled(Stack)(() => ({
  width: '100%',
  marginTop: '3.2rem',
  marginBottom: '1.6rem',
  '& .k-grid-container': {
    border: `0.1rem solid ${offWhiteGray}`,
    borderRadius: '0.8rem',
    overflow: 'hidden',
  },
  '& .k-grid': {
    backgroundColor: abyssColors.primary[50],
    border: 'none',
  },
  '& .k-grid-content::-webkit-scrollbar-track': {
    background: abyssColors.primary[100],
  },
  '& .k-grid-content::-webkit-scrollbar': {
    height: '1.4rem',
  },
  '& .k-grid-content::-webkit-scrollbar-thumb': {
    background: abyssColors.primary[200],
    borderRadius: '1rem',
    border: '0.4rem solid ' + abyssColors.primary[100],
    cursor: 'grabbing',
  },
  '& .k-grid-content': {
    overflowY: 'hidden',
  },
  '& .hide-name span': {
    display: 'none',
  },
  '& .k-grid-header': {
    backgroundColor: abyssColors.primary[50],
    border: 'none',
  },
  '& .k-grid-header th': {
    fontSize: '1.2rem',
    fontWeight: 700,
    color: primary.independence,
    backgroundColor: abyssColors.primary[50],
    border: 'none',
    borderBottom: 'none',
  },
  '& .k-grid-header-wrap': {
    border: 'none',
  },
  '& .k-grid-table tbody tr, & .k-grid-table tbody tr.k-alt': {
    backgroundColor: `${abyssColors.primary[50]} !important`,
  },
  '& .k-grid-table tbody td': {
    fontSize: '1.4rem',
    fontWeight: 400,
    color: abyssColors.primary[500],
    backgroundColor: `${abyssColors.primary[50]} !important`,
    borderLeft: `0.05rem solid ${offWhiteGray}`,
    borderRight: `0.05rem solid ${offWhiteGray}`,
    borderBottom: `0.1rem solid ${offWhiteGray}`,
  },
  '& .k-grid-table tbody td:first-of-type': {
    borderLeft: 'none',
  },
  '& .k-grid-table tbody td:last-of-type': {
    borderRight: 'none',
  },
  '& .k-grid-table tbody td:nth-of-type(n+3)': {
    padding: '2rem 0.8rem',
  },
  '& .k-pager': {
    border: 'none',
    background: 'transparent',
    display: 'flex',
    width: 'fit-content',
    alignSelf: 'flex-end',
    padding: '0',
    marginTop: '2rem',
  },
  '& .k-pager-wrap': {
    justifyContent: 'flex-end',
  },
  '& .k-pager-info': {
    fontSize: '1.2rem',
    fontWeight: 400,
    color: abyssColors.primary[500],
  },
  '& .k-pager-sizes': {
    marginRight: '2.8rem',
  },
  '& .k-pager-sizes span': {
    fontSize: '1.2rem',
    fontWeight: 400,
    color: abyssColors.primary[500],
  },
  '& .k-pager-numbers .k-button-text': {
    fontSize: '1.2rem',
    fontWeight: 400,
    color: abyssColors.primary[500],
  },
  '& .k-pager-sizes .k-dropdown': {
    fontSize: '1.2rem',
  },
  '& .k-pager-sizes .k-dropdown .k-dropdown-wrap': {
    fontSize: '1.2rem',
  },
  '& .k-pager-sizes .k-dropdown .k-input': {
    fontSize: '1.2rem',
    fontWeight: 400,
    color: abyssColors.primary[500],
  },
}));

export const ExceptionSearch = muiStyled(TextField)(() => ({
  flex: 1,
  minWidth: '28rem',
  '& .MuiInputBase-root': {
    background: 'transparent',
    fontSize: '1.2rem',
    color: abyssColors.primary[400],
  },
  '& .MuiInputBase-input': {
    padding: '0.8rem 1.6rem',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
}));

export const ExceptionDropDown = muiStyled(Select)(() => ({
  '&.MuiInputBase-formControl': {
    background: 'transparent',
    fontSize: '1.2rem',
    color: abyssColors.primary[400],
  },
  '& .MuiInputBase-input': {
    padding: '0.8rem 1.6rem',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: abyssColors.primary[200],
  },
}));
